
// ============================================================
// ATLAS THEME — Option 3 Variant Filter
// Hides unavailable option 3 values when option 1 or 2 changes
//
// HOW IT WORKS:
// - Atlas fires "variant-picker:init" on page load
// - Atlas fires "variant-picker:select" on every option change
// - We listen to both and re-filter option 3 based on
//   which option 1 + option 2 are currently selected
// - Liquid handles initial render (sold out hidden on load)
// - This JS handles dynamic filtering after user interaction
// ============================================================

(function () {
  var QV   = '.boost-sd__btn-add-to-cart, .boost-sd__btn-buy-now';
  var PDP  = '[data-part="btn-add-to-cart"]:not(.boost-sd__btn-add-to-cart)';
  var WRAP = '.add-to-cart-btn-wrapper';
  function cfg() { return window.JTPL617 || {}; }
  function msg() { return cfg().message || "This product can't be added to cart."; }

  // Quick view: purana toast
  function notify() {
    var old = document.getElementById('jtpl617-toast');
    if (old) old.remove();
    var t = document.createElement('div');
    t.id = 'jtpl617-toast';
    t.textContent = msg();
    t.style.cssText = 'position:fixed;top:20px;left:50%;transform:translateX(-50%);z-index:999999;background:#b00020;color:#fff;padding:14px 20px;border-radius:6px;font-size:14px';
    document.body.appendChild(t);
    setTimeout(function () { t.remove(); }, 4000);
  }

  // PDP: wrapper ke baad message div (click par hi)
  function notifyPDP(btn) {
    var wrap = btn.closest(WRAP) || document.querySelector(WRAP);
    if (!wrap) { notify(); return; }          // wrapper na mile to toast fallback
    var old = document.getElementById('jtpl617-notice');
    if (old) old.remove();
    var n = document.createElement('div');
    n.id = 'jtpl617-notice';
    n.setAttribute('role', 'alert');
    n.textContent = msg();
    n.style.cssText = 'margin-top:12px;padding:10px 14px;border-radius:6px;background:#b00020;color:#fff;text-align: center;font-size:14px';
    wrap.insertAdjacentElement('afterend', n);
    setTimeout(function () { n.remove(); }, 4000);
  }

  function isZero(id) {
    try {
      var m = document.getElementById('boost-sd__modal-quickview');
      var v = JSON.parse(m.getAttribute('data-product')).variants
        .find(function (x) { return String(x.id) === String(id); });
      return !!v && parseFloat(v.price) === 0 && v.available !== false;
    } catch (e) { return false; }
  }

  document.addEventListener('click', function (e) {
    if (!cfg().enabled) return;
    var qv  = e.target.closest(QV);
    var pdp = !qv && e.target.closest(PDP);
    var block = qv ? isZero(qv.getAttribute('data-variant-id'))
              : pdp ? !pdp.hasAttribute('data-cart-allowed') : false;
    if (block) {
      e.preventDefault();
      e.stopImmediatePropagation();
      if (qv) notify(); else notifyPDP(pdp);
    }
  }, true);
})();

(function () {

  // ── Step 1: Find product JSON ──────────────────────────────
  // Atlas outputs product JSON in a script tag — find it
  // If this logs null, check your theme for the correct selector
  const productJSONEl = document.querySelector(
    '[data-product-json], #product-json, script[type="application/json"][data-product]'
  );

  if (!productJSONEl) {
    console.warn('[VariantFilter] Product JSON not found — check selector');
    return;
  }
// Check 1 — product JSON found?
document.querySelector('[data-product-json], #product-json, script[type="application/json"][data-product]')

// Check 2 — option groups found?
document.querySelectorAll('[data-product-option]').length // should be 3

// Check 3 — events firing?
document.addEventListener('variant-picker:select', e => console.log('fired!', e));
// then click an option — should log "fired!"
  let productJSON;
  try {
    productJSON = JSON.parse(productJSONEl.textContent);
  } catch (e) {
    console.warn('[VariantFilter] Failed to parse product JSON', e);
    return;
  }

  // ── Step 2: Check product has 3 options ───────────────────
  if (!productJSON.options || productJSON.options.length < 3) {
    // Product has fewer than 3 options — nothing to do
    return;
  }

  // ── Step 3: Read currently checked value for an option ────
  // Atlas groups options inside [data-product-option] elements
  // optionPosition: 0 = first option, 1 = second, 2 = third
  function getCheckedValue(optionPosition) {
    const optionGroups = document.querySelectorAll('[data-product-option]');
    const group = optionGroups[optionPosition];
    if (!group) return null;

    const checked = group.querySelector('input[type="radio"]:checked, option:checked');
    return checked ? checked.value : null;
  }

  // ── Step 4: Find which option 3 values are available ──────
  // Checks ALL variants to find which option3 values exist
  // when combined with the given opt1 + opt2 selection
  function getAvailableOption3Values(opt1, opt2) {
    const available = new Set();

    productJSON.variants.forEach(function (variant) {
      if (
        variant.available &&       // must be in stock
        variant.option1 === opt1 && // must match selected option 1
        variant.option2 === opt2 && // must match selected option 2
        variant.option3             // must have an option 3 value
      ) {
        available.add(variant.option3);
      }
    });

    return available; // Set of available option3 value strings
  }

  // ── Step 5: Show/hide option 3 radio inputs ───────────────
  // This is the main function that runs after every option change
  function updateOption3(opt1, opt2) {
    // Get the third [data-product-option] group
    const optionGroups = document.querySelectorAll('[data-product-option]');
    const option3Group = optionGroups[2];

    if (!option3Group) return; // no third option group found

    // All radio inputs inside option 3
    const option3Inputs = option3Group.querySelectorAll('input[type="radio"]');
    if (!option3Inputs.length) return;

    // Which values are valid for current opt1 + opt2 combo
    const availableValues = getAvailableOption3Values(opt1, opt2);

    let firstAvailable  = null;  // first visible input (to auto-check if needed)
    let hasCheckedVisible = false; // is the currently checked input still visible?

    option3Inputs.forEach(function (input) {
      const wrap = input.closest('.option-value-radio'); // your Liquid wrapper div
      const isAvailable = availableValues.has(input.value);

      if (isAvailable) {
        // Show this option
        if (wrap) wrap.style.display = '';
        input.disabled = false;

        // Track first available for fallback
        if (firstAvailable === null) firstAvailable = input;

        // Is the currently checked one still valid?
        if (input.checked) hasCheckedVisible = true;

      } else {
        // Hide this option — not valid for current combo
        if (wrap) wrap.style.display = 'none';
        input.disabled = true;
        if (input.checked) input.checked = false;
      }
    });

    // If the previously checked option 3 is now hidden,
    // auto-select the first available one
    if (!hasCheckedVisible && firstAvailable) {
      firstAvailable.checked = true;

      // Dispatch Atlas's own change event so it processes the new selection
      // This triggers variant-picker:select which updates price, availability etc.
      firstAvailable.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  // ── Step 6: Run on Atlas's variant-picker:select event ────
  // Fires every time the customer clicks an option
  document.addEventListener('variant-picker:select', function () {
    // Small delay — let Atlas finish updating its internal state first
    setTimeout(function () {
      const opt1 = getCheckedValue(0); // currently selected option 1
      const opt2 = getCheckedValue(1); // currently selected option 2

      if (opt1 && opt2) {
        updateOption3(opt1, opt2);
      }
    }, 50);
  });

  // ── Step 7: Run on Atlas's variant-picker:init event ──────
  // Fires once on page load after the variant picker is ready
  document.addEventListener('variant-picker:init', function () {
    setTimeout(function () {
      const opt1 = getCheckedValue(0);
      const opt2 = getCheckedValue(1);

      if (opt1 && opt2) {
        updateOption3(opt1, opt2);
      }
    }, 150); // slightly longer delay on init — Atlas needs more setup time
  });

})();

(function () {
  function injectStyleIntoShadow() {
    const megaMenus = document.querySelectorAll('mega-menu');

    megaMenus.forEach(menu => {
      const shadow = menu.shadowRoot;
      if (!shadow) return;

      // Prevent duplicate injection
      if (shadow.querySelector('#custom-mega-style')) return;

      const style = document.createElement('style');
      style.id = 'custom-mega-style';

      style.textContent = `
        sticky-header.header-wrapper mega-menu .mega-menu-panel,
        .mega-menu-panel {
          padding: 1.6rem !important;
              overflow-y: auto !important;
          max-height: 80% !important;
          box-shadow: none !important;
          backdrop-filter: blur(32px);
          -webkit-backdrop-filter: blur(31px);
              background: linear-gradient(96.86deg, rgba(7, 25, 78, 0.1) 46.3%, rgba(30, 93, 186, 0.1) 78.23%) !important;
      }
        sticky-header.header-wrapper mega-menu .mega-menu-panel::after,
        .mega-menu-panel::after {
           position: absolute;
            content: '';
            inset: 0;
            opacity: .7;
            background: linear-gradient(96.86deg, rgba(7, 25, 78, 0.8) 46.3%, rgba(30, 93, 186, 0.8) 78.23%);
            pointer-events: none;
            backdrop-filter: blur(32px);
        }
        .mega-menu-panel::-webkit-scrollbar-track {
          border-radius: 10px;
          background-color: #051442;
        }
        .mega-menu-panel::-webkit-scrollbar {
          width: 12px; 
          border-radius: 10px;
          background-color: #143885;
        }
        .mega-menu-panel::-webkit-scrollbar-thumb {
          border-radius: 10px;
          background-color: #143885;
        }
      `;

      shadow.appendChild(style);
    });
  }

  // Retry (Shopify async load fix)
  let tries = 0;
  const interval = setInterval(() => {
    injectStyleIntoShadow();
    tries++;
    if (tries > 20) clearInterval(interval);
  }, 300);

  // Observe dynamic DOM changes
  const observer = new MutationObserver(() => {
    injectStyleIntoShadow();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });



  document.addEventListener('DOMContentLoaded', function () {
  const carousels = document.querySelectorAll('.carousel--collection-list');

  carousels.forEach(carousel => {
    const track = carousel.querySelector('#track');

    console.log(track); // debug

    if (track) {
      track.style.display = 'flex';
    }
  });

  const interval = setInterval(function () {
  const wrapper = document.querySelector(".boost-sd__search-bar-wrapper--mobile");

  if (wrapper) {
    clearInterval(interval); // mil gaya → interval band

    document.querySelectorAll(".boost-sd__search-bar-wrapper--mobile .boost-sd__button-text-x--close-style1")
      .forEach(function (element) {
        element.addEventListener("click", function () {
          console.log("click");
          document.querySelector(".mobile-panel-theme .search-panel-mobile__top .search-panel-mobile__close-wrapper")?.click();
        });
      });
  }
}, 500);

});


})();

// pre order msg on variant chnage
document.addEventListener('DOMContentLoaded', function () {
document.addEventListener('change', function(e) {
  if (!e.target.matches('.option-value-radio input')) return;

  const el = e.target;

  const variantId = el.dataset.variantId;
  const inventoryQty = el.dataset.inventoryQty;
  const inventoryPolicy = el.dataset.inventoryPolicy;

  const preorderContainer = document.getElementById('preorder-container');

  if (!preorderContainer) return;

  // skip incomplete variant
  if (!variantId || inventoryQty === "" || inventoryPolicy === "") {
    preorderContainer.style.display = 'none';
    return;
  }

  const qty = parseInt(inventoryQty);

  if (qty <= 0 && inventoryPolicy === 'continue') {
    preorderContainer.style.display = 'block';
  } else {
    preorderContainer.style.display = 'none';
  }
});
// ✅ default page load
window.addEventListener('load', function() {
  const checked = document.querySelector('.option-value-radio input:checked');

  if (!checked) return;

  const variantId = checked.dataset.variantId;
  const inventoryQty = checked.dataset.inventoryQty;
  const inventoryPolicy = checked.dataset.inventoryPolicy;

  const preorderContainer = document.getElementById('preorder-container');

  if (!preorderContainer) return;

  if (!variantId || inventoryQty === "" || inventoryPolicy === "") return;

  const qty = parseInt(inventoryQty);

  if (qty <= 0 && inventoryPolicy === 'continue') {
    preorderContainer.style.display = 'block';
  }
});
});
// end script for pre order varinat chnage
// product page variant meta fild change on change variant Start (RB) 
// product page variant meta field change on variant change

document.addEventListener('DOMContentLoaded', function () {

  document.addEventListener('change', function(e){

    if(!e.target.matches('.option-value-radio input')) return;

    const clickedValue = e.target.value.trim();

    setTimeout(() => {

      // ✅ Safety check
      if (!window.productData || !window.productData.variants) {
        console.error("productData missing");
        return;
      }

      // ✅ Get selected options
      const selectedOptions = [];
      document.querySelectorAll('.option-value-radio input:checked').forEach(input => {
        selectedOptions.push(input.value.trim());
      });

      // console.log("selectedOptions:", selectedOptions);

      // ✅ Exact variant match (FIXED)
      let variant = window.productData.variants.find(v =>
        v.options.join('|') === selectedOptions.join('|')
      );

      // ✅ Fallback (closest match)
      if(!variant){
        variant = window.productData.variants.find(v =>
          v.options.includes(clickedValue)
        );
      }

      // console.log("FINAL variant:", variant);

      if(!variant) return;

      const variantId = variant.id;

      const url = window.location.pathname + '?variant=' + variantId;

      // ✅ Fetch updated HTML
      fetch(url)
        .then(res => res.text())
        .then(html => {

          const doc = new DOMParser().parseFromString(html, 'text/html');

          const newSpecs = doc.querySelector('.block-product-specifications');
          const currentSpecs = document.querySelector('.block-product-specifications');

          if(newSpecs && currentSpecs){
            currentSpecs.replaceWith(newSpecs);
          } else {
            console.warn("Specification block not found");
          }

        })
        .catch(err => {
          console.error("Fetch error:", err);
        });

    }, 50);

  });

});
// For external link in header menu"RMA"
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll("a").forEach(link => {
    
    const href = link.href;

    // Condition: RMA link OR any PDF from Shopify CDN
    if (
      href.includes("contrinex.my.site.com/RMACaseCreation") ||
      (href.includes("cdn.shopify.com") && href.includes(".pdf"))
    ) {
      link.setAttribute("target", "_blank");
      link.setAttribute("rel", "noopener noreferrer");
    }

  });
});

document.querySelectorAll('.mobile-menu__link .menu-title-link').forEach(link => {
  link.addEventListener('click', function(e) {
    e.stopPropagation(); // accordion toggle rokega
  });
});
document.addEventListener("DOMContentLoaded", function () {
/* ==============================
      UPDATE STOCK UI FUNCTION
   ============================== */
if(document.body.classList.contains("template-collection")){
  // document.addEventListener("click", function(e) {
  //   if(e.target.closest(".boost-sd__product-image-column") || e.target.closest(".boost-sd__product-swatch-option")){
  //     var mainDiv = document.querySelector(".boost-sd__product-swatch-option-wrapper");
  //    if(mainDiv){ 
  //     mainDiv.classList.add("loader");
  //    }
  //     setTimeout(function(){
  //       getText();
  //       if(!e.target.closest(".boost-sd__product-swatch-end")){
  //         console.log("enter");
  //         filterDependentOptions(e);
  //       }
  //     }, 500);
  //   }
  // });
  let timeoutId;

document.addEventListener("click", function(e) {
  const target = e.target;

  if (
    target.closest(".boost-sd__product-image-column") ||
    target.closest(".boost-sd__product-swatch-option")
  ) {
    var mainDiv = document.querySelector(".main-quick-view");

    if (mainDiv) { 
      mainDiv.classList.add("loader");
    }

    // clear previous timeout
    clearTimeout(timeoutId);

    timeoutId = setTimeout(function() {
      getText();

      if (!target.closest(".boost-sd__product-swatch-end")) {
        console.log("enter");
        filterDependentOptions(e);
      }
    }, 500);
  }
});

  function getText(){
    var linkEl = document.querySelector(".boost-sd__quick-view-details-link");
    if (!linkEl) return;

    var link = linkEl.getAttribute("href");
    var buttontext = document.querySelectorAll(".btn-add-to-cart .button__label");
    fetch(link)
      .then(res => res.text())
      .then(function(data) {

        var doc = new DOMParser().parseFromString(data, "text/html");
        var stock = doc.querySelector(".product-info .product-stock");
        var estimated = doc.querySelector(".product-info .preorder-container-wrapper");

         // JTPL-617: price 0 => quick view add to cart hide
        var zeroPrice = doc.querySelector('[data-price-zero="true"]');
        document.querySelectorAll(".main-quick-view .boost-sd__btn-add-to-cart")
          .forEach(function (btn) {
            btn.disabled = !!zeroPrice;
            btn.classList.toggle("disable", !!zeroPrice);
          });

        // Buy it now button: isko disable hi rakho (ya hide, jaisa chaho)
        document.querySelectorAll(".main-quick-view .boost-sd__btn-buy-now")
          .forEach(function (btn) {
            btn.disabled = !!zeroPrice;
            btn.classList.toggle("disable", !!zeroPrice);
          });

        var Stockmessage = document.querySelector(".restock-text");
        var estimatedmessage = document.querySelector(".estimated-delivery-container");

        if (estimatedmessage) estimatedmessage.innerHTML = "";
        if (Stockmessage) Stockmessage.innerHTML = "";
        if (stock && Stockmessage) {
          buttontext.forEach(btn => btn.innerHTML = "ADD TO CART");
          Stockmessage.innerHTML = stock.outerHTML;
        }
        if (estimated && estimatedmessage) {
          buttontext.forEach(btn => btn.innerHTML = "ORDER NOW");
          estimatedmessage.innerHTML = estimated.outerHTML;
        } 
        var mainDiv = document.querySelector(".main-quick-view");
        if(mainDiv){
          setTimeout(function(){ 
          mainDiv.classList.remove("loader");
          }, 1500);
          }
      })
      .catch(err => console.error("Error:", err));
  }

  function filterDependentOptions(e) {
    let selected = [];
    document.querySelectorAll(
      ".boost-sd__radio-label--in-quick-view.boost-sd__radio-label--selected"
    ).forEach(function (el, index) {
      selected[index] = el.textContent.trim();
    });

    var link = document
      .querySelector(".boost-sd__quick-view-details-link")
      .getAttribute("product-link");
    fetch(link)
      .then(res => res.text())
      .then(function(data) {
        var doc = new DOMParser().parseFromString(data, "text/html");
        var variantEls = doc.querySelectorAll(".product-option-variants");
        let variants = [];
        variantEls.forEach(function (el) {
          let options = el.getAttribute("data-option-name")
            .split(" ! ")
            .map(v => v.trim());
          variants.push(options);
        });
        document.querySelectorAll(".boost-sd__product-swatch")
        .forEach(function (group, groupIndex) {
          let radios = group.querySelectorAll(".boost-sd__radio-label--in-quick-view");
          radios.forEach(function (radio) {
            let value = radio.textContent.trim();
            let isValid = false;

            variants.forEach(function (variant) {
              let match = true;
              for (let i = 0; i < groupIndex; i++) {
                if (selected[i] && variant[i] !== selected[i]) {
                  match = false;
                  break;
                }
              }
              if (match && variant[groupIndex] === value) {
                isValid = true;
              }
            });

            if (isValid) {
              radio.closest(".boost-sd__product-swatch-option").style.display = "inline-block";
              radio.style.display = "inline-block";
              radio.classList.remove("disabled");
            } else {
              radio.closest(".boost-sd__product-swatch-option").style.display = "none";
              radio.style.display = "none";
              radio.classList.add("disabled");
            }
          const swatchOptions = document.querySelectorAll(".boost-sd__product-swatch-options");

          if (swatchOptions.length > 0) {
              const lastEl = swatchOptions[swatchOptions.length - 1];
              const options = lastEl.querySelectorAll(".boost-sd__product-swatch-option");
              
              for (let i = 0; i < options.length; i++) {
                  const currentOption = options[i];
                  const style = currentOption.getAttribute("style");
                  currentOption.classList.remove("added");
                  // console.log(currentOption);
                  if (style && style.includes("display: inline-block")) {
                      currentOption.classList.add("added");
                      
                      setTimeout(function(){
                          options.forEach(function(opt) {
                              const otherInput = opt.querySelector("input.boost-sd__radio-input");
                              const otherLabel = opt.querySelector("label.boost-sd__radio-label");
                              // if (otherInput) {
                              //     otherInput.setAttribute('checked', false);
                              // }
                              // if (otherLabel) {
                              //     otherLabel.classList.remove("boost-sd__radio-label--selected");
                              // }
                          });
                          const inputField = currentOption.querySelector("input.boost-sd__radio-input");
                          const labelField = currentOption.querySelector("label.boost-sd__radio-label");
                          if (inputField) {
                              // inputField.setAttribute('checked', true);
                              inputField.click();
                          }
                          // if (labelField) {
                          //     labelField.classList.add("boost-sd__radio-label--selected");
                          // }
                      }, 50);
                      break;
                  }

              }
          }
          });
        });
      });
  }
}
});